import React from 'react';
import './Carousel.scss';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Countdown from '../Countdown/Countdown';

const CarouselItem = (props) => {
  return (
    <a className="slide-item-link" href={props.ctaLink}>
      <section className="slide-item">
        <div className="slide-item__content slide-item__content--right">
          <div className="slide-content">
            <div className="slide-content__content">

            <h1>
              <span className="heading" style={{ '--primaryColor': props.primaryColor || '#908871' }}>
                {props.title}
              </span>
              <br />
              <span
                className="sub-heading"
                style={{ '--primaryColor': props.primaryColor || '#908871' }}
              >
                {props.subTitle}
              </span>
            </h1>

            <div className="slide-content__ctas">
              <button style={{ '--primaryColor': props.primaryColor || '#908871' }} className="r-button">
                {props.ctaText}
              </button>
              {(props.countdownText || props.countdownText !== "0000/00/00") && props.countdownDate &&
                <Countdown 
                  primaryColor={props.primaryColor || '#908871'}
                  title={props.countdownText}
                  endDate={`${props.countdownDate.replace(/\//g, '-')}T00:00:00`}
                />
              }

            </div>

            </div>
                <div 
                
                style={{
                  backgroundImage: `url(${props.imgUrl})`,
                }}
                className="slide-content__mobile-bg" />
              </div>
        </div>
        <div
          className="slide-item__image"
          style={{
            backgroundImage: `url(${props.imgUrl})`,
          }}
        >
          <div className="slide-item__content-bg">
            <div
              className="slide-item__content-bg-img"
              style={{
                backgroundImage: `url(${props.imgUrl})`,
              }}
            ></div>
          </div>
        </div>
      </section>
    </a>
  );
};

export default CarouselItem;
